import { Component, Output, EventEmitter, ViewChild, ElementRef } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { DataImportService } from "../../services/dataimport.service";
import { ToastrService } from "ngx-toastr";

@Component({
    selector: "importfile",
    templateUrl: "./importfile.component.html",
    standalone: true,
    imports: [CommonModule]
})
export class ImportFileComponent {
    @Output() uploadCompleteEvent = new EventEmitter();
    uploadErrors: string[] = [];
    showValidationErrors: boolean = false;
    showInput: boolean = false;
    @ViewChild("fileUpload") fileUploadCtrl: ElementRef;

    constructor(private httpClient: HttpClient, private toastr: ToastrService, private dataImportService: DataImportService) {
    }

    fileChange(event: any): void {
        let fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            let file: any = fileList[0];
            let formData: FormData = new FormData();
            formData.append("fileUpload", file, file.name);
            this.showValidationErrors = false;
            this.dataImportService.importFile(formData).subscribe(
                (res: any) => {
                    let data: string[] = res;
                    if (data && data.length > 0) {
                        this.uploadErrors = data;
                        this.toastr.error("File cannot be uploaded");
                        this.showValidationErrors = true;
                    } else {
                        this.toastr.success("File upload successful");
                    }

                    // reset input to be able to detect file change event
                    this.fileUploadCtrl.nativeElement.value = "";
                    this.uploadCompleteEvent.emit();
                },
                () => {
                    // reset input to be able to detect file change event
                    this.fileUploadCtrl.nativeElement.value = "";
                }
            );
        }
    }
}


